// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leftBarComp {
  width: 50%;
  height: 100%;
  background-color: var(--Foreground);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  border-radius: 0rem 1rem 1rem 0rem;
}
.leftBarComp h1 {
  width: 100%;
  font-size: 2rem;
  font-weight: 600;
  text-align: center;
  color: var(--AccentColor);
}
.leftBarComp p {
  width: 70%;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  color: var(--TextColor);
}
.leftBarComp .formCompletion {
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.leftBarComp .formCompletion div {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.25rem;
}
.leftBarComp .formCompletion div .inactive {
  opacity: 0.6;
  text-align: left;
}
.leftBarComp .formCompletion div .completed {
  color: var(--AccentColor);
  text-align: left;
}
.leftBarComp .formCompletion div .active {
  text-align: left;
}

.animationComp {
  width: 50%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 1050px) {
  .animationComp .companyInfoBg {
    width: 70%;
    min-height: 60%;
  }
  .animationComp .overviewBg {
    width: 70%;
    min-height: 60%;
  }
  .animationComp .detailsBg {
    width: 70%;
    max-height: 75%;
  }
}
@media (max-width: 700px) {
  .animationComp .companyInfoBg {
    width: 80%;
    min-height: 50%;
  }
  .animationComp .overviewBg {
    width: 80%;
    min-height: 50%;
  }
  .animationComp .detailsBg {
    width: 80%;
    max-height: 60%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/CompanyRegistration/Info/Info.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,YAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kCAAA;AACJ;AAAI;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAER;AAAI;EACI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AAER;AAAI;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAER;AADQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAGZ;AAFY;EACI,YAAA;EACA,gBAAA;AAIhB;AAFY;EACI,yBAAA;EACA,gBAAA;AAIhB;AAFY;EACI,gBAAA;AAIhB;;AAEA;EACI,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEA;EAEQ;IACI,UAAA;IACA,eAAA;EAAV;EAEM;IACI,UAAA;IACA,eAAA;EAAV;EAEM;IACI,UAAA;IACA,eAAA;EAAV;AACF;AAGA;EAEQ;IACI,UAAA;IACA,eAAA;EAFV;EAIM;IACI,UAAA;IACA,eAAA;EAFV;EAIM;IACI,UAAA;IACA,eAAA;EAFV;AACF","sourcesContent":[".leftBarComp{\n    width: 50%;\n    height: 100%;\n    background-color: var(--Foreground);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1.25rem;\n    border-radius: 0rem 1rem 1rem 0rem;\n    h1{\n        width: 100%;\n        font-size: 2rem;\n        font-weight: 600;\n        text-align: center;\n        color: var(--AccentColor);\n    }\n    p{\n        width: 70%;\n        font-size: 1rem;\n        font-weight: 600;\n        text-align: center;\n        color: var(--TextColor);\n    }\n    .formCompletion{\n        width: 70%;\n        display: flex;\n        flex-direction: column;\n        gap: 1.25rem;\n        div{\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 1.25rem;\n            .inactive{\n                opacity: .6;\n                text-align: left;\n            }\n            .completed{\n                color: var(--AccentColor);\n                text-align: left;\n            }\n            .active{\n                text-align: left;\n            }\n        }\n    }\n}\n\n.animationComp{\n    width: 50%;\n    height: 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@media (max-width: 1050px){\n    .animationComp{\n        .companyInfoBg{\n            width: 70%;\n            min-height: 60%;\n        }\n        .overviewBg {\n            width: 70%;\n            min-height: 60%;\n        }\n        .detailsBg{\n            width: 70%;\n            max-height: 75%;\n        }\n    }\n}\n@media (max-width: 700px){\n    .animationComp{\n        .companyInfoBg{\n            width: 80%;\n            min-height: 50%;\n        }\n        .overviewBg {\n            width: 80%;\n            min-height: 50%;\n        }\n        .detailsBg{\n            width: 80%;\n            max-height: 60%;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
